export const alphanumericRegex = /^[a-zA-Z0-9]+$/;
export const latinLettersNumericRegex = new RegExp(/^[a-z0-9\s-_.,]+$/i);
export const onlyAlphanumericRegex = /[^a-zA-Z0-9]/g;
/** Company name / legal name: latin letters, digits, spaces, dot, comma, hyphen/dash, ampersand, apostrophe. Same set as in oms-frontend. */
export const companyNameRegex = /^[a-zA-Z0-9\s.,&'’–—-]+$/;
